// extracted by mini-css-extract-plugin
export default {"appHeader":"Header_appHeader__NyjYs","logo":"Header_logo__nZ7K6"};